import ReactGA from 'react-ga4';
import googleAnalyticsConfig from './googleAnalytics.config';
import { Analytics } from '../analytics';
import { renameObjectKeys } from '../../../utils/utils';
import { MetadataKey, Metadata } from '../../metadata';

// Map our internal values to those required by Google Analytics
const analyticsUserKeysMap: Partial<Record<MetadataKey, string>> = {
  did: 'userId',
  validationId: 'dimension1',
  flowId: 'dimension2',
  networkAddress: 'dimension3',
  transactionFee: 'dimension4',
};

export default class GoogleAnalytics implements Analytics {
  initialize(): void {
    const env = process.env.REACT_APP_STAGE;
    if (env && googleAnalyticsConfig[env]) {
      ReactGA.initialize(googleAnalyticsConfig[env], {
        gaOptions: { cookieFlags: 'samesite=none;secure' },
      });
    }
  }

  updateFromMetaData(keys: Metadata): void {
    if (ReactGA.isInitialized) {
      const renamedKeys = renameObjectKeys(keys, analyticsUserKeysMap);
      ReactGA.set(renamedKeys);
    }
  }

  pageView(title: string): void {
    if (ReactGA.isInitialized) {
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title });
    }
  }
}
